import { render, staticRenderFns } from "./ProductSpecifications.vue?vue&type=template&id=35d8c0d9&scoped=true"
import script from "./ProductSpecifications.vue?vue&type=script&lang=js"
export * from "./ProductSpecifications.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecifications.vue?vue&type=style&index=0&id=35d8c0d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8c0d9",
  null
  
)

export default component.exports